<template>
    <div class="w-100 m-0 d-flex justify-content-center">
        <div class="container-inputs p-3 position-relative">
            <Breadcrumbs :breadcrumbs="breadcrumbs" />

            <h1 class="display-4 text-white fw-normal title">Afgeronde ziekmelding</h1>
            <hr />

            <div class="col disability-information" style="display: none;">
                <p class="text-white mb-1">
                    <strong>Start: </strong> {{ $formatDate(disability?.start_at) }}
                </p>

                <p class="text-white mb-1">
                    <strong>Einde: </strong> {{ $formatDate(disability?.end_at) }}
                </p>

                <hr class="dashed"/>
            </div>


            <!-- Beschrijving ziekmelding -->
            <div style="display: none;" class="disability-information">
                <div class="col">
                    <h6 class="text-white mb-2">Bechrijving</h6>
                </div>
                <div class="col">
                    <p class="text-white" v-html="disability?.description"></p>
                </div>
                <div class="col">
                    <hr/>
                </div>
            </div>


            <!-- Verloop -->
            <h4 class="text-white fw-normal">Arbeidsongeschiktheidsverloop</h4>

            <div class="p-3 rounded-2 text-start small text-dark bg-info mb-2 w-100" id="updateField" style="display: none;">
                    <i class="fa fa-info-circle me-1"></i> Dit is het verloop van je arbeidsongeschiktheid op basis van bevindingen en vastleggingen van een arbo&#8209;arts of de casemanager.
                <div class="m-0 mt-2" id="doctor-updates" style="display: none;">
                    <i class="fa fa-times me-1"></i> Er zijn geen gegevens ingevuld door een arbo-arts.
                </div>
            </div>

            <table id="arboUpdates" class="table w-100" style="display: none;">
                <thead>
                    <tr>
                        <th class="text-white">Datum</th>
                        <th class="text-white">Beschrijving</th>
                        <th class="text-white">Percentage</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="course in disabilityCourse" :key="course.id">
                        <td class="text-white">{{ $formatDate(course.medical_examination_done_at) }}</td>
                        <td class="text-white" v-html="course.description || 'Geen beschrijving'"></td>
                        <td class="text-white">{{ course.disability_part * 100 }}&percnt;</td>
                    </tr>
                </tbody>
            </table>

            <!-- Updates over je ziekmelding -->
            <h4 class="text-white fw-normal mt-4">Updates</h4>

            <!-- Als er geen updates verzonden zijn -->
            <p class="p-3 rounded-2 bg-info text-dark m-0 small w-100" id="noUpdates" style="display: none;"><i class="fa fa-info-circle me-1"></i> Er zijn geen updates over deze ziekmelding verzonden.</p>

            <div class="btn btn-primary my-2" id="showUpdates" @click="toggleUpdates" v-if="disabilityCustomerUpdates.length > 0"><i :class="['fa fa-chevron-down me-1', openUpdates ? 'rot-180' : '']"></i> Toon updates</div>

            <div id="updates" class="w-100" style="display: none;">
                <table class="table w-100">
                    <thead>
                        <tr>
                            <td class="text-white">Datum</td>
                            <td class="text-white">Beschrijving</td>
                            <td class="text-white">Voortgang</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="update in disabilityCustomerUpdates" :key="update.id">
                            <td class="text-white">{{ $formatDate(update.created_at) }}</td>
                            <td class="text-white" v-html="update.description "></td>
                            <td :class="['text-center position-relative', update.development === -1 ? 'text-danger text-brighter bg-worse' : 'text-white bg-neutral', update.development === 1 ? 'text-success bg-better' : '']"><i :class="['fa middle', icons[update.development+1]]"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import $ from 'jquery';
import { Breadcrumb, isKnab, updateAppearanceKnab } from '@/App.vue';
import Breadcrumbs from '@/components/BreadcrumbsComponent.vue';
// import { useToast } from 'vue-toastification';

export default {
    name: 'finished-disability-component',
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            disabilityCourse: [],
            disabilityCustomerUpdates: [],
            icons: ['fa-arrow-down', 'fa-minus', 'fa-arrow-up'],
            breadcrumbs: [new Breadcrumb("/disability", "Mijn gezondheid"), new Breadcrumb(`/disability/finished/${this.$route.params.id}`, "Ziekmelding")],
        }
    },
    methods: {

        async getDisability() {
            // Haal ziekmeldingen op uit de database en toon updates voor deze ziekmelding
            await this.$http.get(`disabilities/${this.$route.params.id}`)
                .then((response) => {
                    this.disability = response.data;

                    if(this.disability) {
                        $(".disability-information").show(400);
                    }

                    this.disabilityCourse = this.disability.course_of_disabilities.reverse();
                    this.disabilityCustomerUpdates = this.disability.disability_customer_updates.reverse();

                    if(!this.disabilityCourse.length) {
                        $("#doctor-updates").show(400);
                    } else {
                        $("#arboUpdates").show(400);
                    }

                    $("#updateField").show(400);

                    if(!this.disabilityCustomerUpdates.length)
                        $("#noUpdates").show(400);
            }).then(() => {
                if(isKnab()) {
                    updateAppearanceKnab();
                    $(".text-white").removeClass("text-white");
                    $(".btn-danger, #doctor-updates").removeClass("crowdsurance");
                }
            });
        },

        toggleUpdates() {
            this.openUpdates = !this.openUpdates;

            if(this.openUpdates) {
                $("#updates").show(400);
                $("#showUpdates > i.fa.fa-chevron-down").addClass('rot-180');
            } else {
                $("#updates").hide(400);
                $("#showUpdates > i.fa.fa-chevron-down").removeClass('rot-180');
            }
        },

        monthDiff(d1, d2) {
            let months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 0 : months;
        },

    },
    mounted() {
        // Ziekmelding inladen en historie tonen
        this.getDisability();
    }
}
</script>


<!-- Styling -->
<style scoped>
hr {
    border-color: rgba(255, 255, 255, 0.5);
}

.dashed {
    border-style: dashed !important;
}

.update {
    color: var(--light-blue);
}

table tr td,
table tr,
th {
    background-color: transparent !important;
}

h6 {
    font-weight: 800;
}

.bg-neutral {
    background-color: rgba(255, 255, 255, 0.2) !important;
}

.bg-better {
    background-color: rgba(0, 255, 64, 0.2) !important;
}

.bg-worse {
    background-color: rgba(255, 0, 0, 0.2) !important;
}

.rot-180 {
    transform: rotateZ(180deg);
}

#showUpdates > i{
    transition: all 400ms ease-out;
}
</style>